export const formatExtraLabel = (
  name: string | undefined,
  quantity: number | undefined,
  separator: 'x' | '×' = '×'
): string => {
  if (!name || !name.trim()) return '';
  return quantity != null && quantity > 1 ? `${name} ${separator} ${quantity}` : name;
};
